// extracted by mini-css-extract-plugin
export default {"card":"OurStory_card__2TqVF","parallax":"OurStory_parallax__EX9Mm","sticky":"OurStory_sticky__9z-tA"};